import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../../redux/Slices/modalSlice';
import { useTheme } from '../../context/ThemeContext';

import ImagePlaceholder from '../Global/ImagePlaceholder';
import AccountSwitcher from './AccountSwitcher';
import './scss/index.scss';
import { config } from '../../config';
import useHandlePopoverClick from '../../hooks/useHandlePopoverClick';
import PreferredTheme from '../Global/PreferredTheme';
import accountSwitchingService from '../../services/accountSwitchingService';
import SwitchAccount from '../icons/SwitchAccount';

import { togglePopover } from '../../redux/Slices/popoverSlice';
const ProfileDropdown = ({ setIsShowProfile }) => {
    const { user } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { theme } = useTheme();
    const [isThemePopoverVisible, setIsThemePopoverVisible] = useState(false);
    const [isAccountSwitcherVisible, setIsAccountSwitcherVisible] = useState(false);

    const { handlePopoverClick } = useHandlePopoverClick();

    const hideProfile = () => {
        setIsShowProfile(false);
        dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
    };

    const handleCreateWorkspace = () => {
        dispatch(openModal({ modalType: 'CREATE_WORKSPACE', modalData: {} }));
        hideProfile();
    };

    const handleLogout = async (e) => {
        e.preventDefault();

        try {
            await fetch(config.API_URI + '/v1/users/auth/logout', {
                method: 'POST',
                credentials: 'include',
            });
        } catch (err) {
            console.error('Logout failed:', err);
        }

        navigate('/login');
        window.location.reload();
    };


    // Toggle PreferredTheme visibility
    const toggleThemePopover = () => {
        setIsThemePopoverVisible(!isThemePopoverVisible);
    };

    // Toggle AccountSwitcher visibility
    const toggleAccountSwitcher = () => {
        setIsAccountSwitcherVisible(!isAccountSwitcherVisible);
    };

    // Check if user has multiple accounts
    const hasMultipleAccounts = accountSwitchingService.hasMultipleAccounts();


    return (
        <div className="zoobbe-profile">
            <div className="account-section">
                {user?.user?.profilePicture ? (
                    <img
                        className="profile-picture"
                        src={user?.user?.profilePicture}
                        alt={user?.user?.username}
                        loading="lazy"
                    />
                ) : (
                    <ImagePlaceholder
                        key={user?.user?._id}
                        size={50}
                        member={user?.user}
                        text={user?.user?.username}
                    />
                )}
                <div className="account-info">
                    <p className="username">{user?.user?.username}</p>
                    <p className="email">{user?.user?.email}</p>
                </div>
            </div>
            <div className="menu-section">
                <p className="menu-title">Zoobbe</p>
                <ul>
                    <li><Link onClick={hideProfile} to={`/u/${user?.user?.username}/profile`}>Profile and visibility</Link></li>
                    {user?.user?.verified && (
                        <>
                            <li><Link onClick={hideProfile} to={`/u/${user?.user?.username}/activity`}>Activity</Link></li>
                            <li><Link onClick={hideProfile} to={`/u/${user?.user?.username}/cards`}>Cards</Link></li>
                            <li><Link onClick={hideProfile} to={`/u/${user?.user?.username}/settings`}>Settings</Link></li>
                        </>
                    )}

                    <li id='popover-preferred-theme'>
                        <button
                            onClick={toggleThemePopover} // Toggle visibility on click
                        > Theme
                            {theme == 'dark' && <span className="material-symbols-outlined">dark_mode</span>}
                            {theme == 'light' && <span className="material-symbols-outlined">light_mode</span>}
                            {theme == 'system' && <span className="material-symbols-outlined">contrast</span>}

                        </button>
                        {isThemePopoverVisible && <PreferredTheme />}
                    </li>
                </ul>
            </div>
            {user?.user?.verified && (
                <div className="workspace-section">
                    <button className="create-workspace" onClick={handleCreateWorkspace}>
                        Create Workspace
                    </button>
                </div>
            )}
            <div className="other-section">
                <ul>
                    <li className='full-deactivated'><Link to="#">Help</Link></li>
                </ul>
            </div>
            {user?.user?.verified && (
                <div className="workspace-section">
                    <Link className="export-import-board" onClick={hideProfile} to="/import">
                        Import / Export
                    </Link>
                </div>
            )}
            <div className="logout-section">
                <ul>
                    <li id='popover-account-switcher'>
                        <button onClick={toggleAccountSwitcher} className='account-switcher-button'>
                            Switch accounts
                            {hasMultipleAccounts && <span className="account-count">{accountSwitchingService.getAccountCount()}</span>}
                        </button>
                        {isAccountSwitcherVisible && (
                            <AccountSwitcher onClose={() => setIsAccountSwitcherVisible(false)} />
                        )}
                    </li>
                    <li id='popover-logout'>
                        <button onClick={handleLogout} className='logout-button'>
                            Log out
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ProfileDropdown;
